/* eslint-disable array-callback-return */
import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getConceptAndFormulasAPI,
  searchConceptsAPI,
  getConceptDetailsAPI,
  createConceptAndFormulasAPI,
  modifyConceptAndFormulasAPI,
  deleteConceptAndFormulasAPI,
  duplicateConceptAndFormulasAPI,
  getFunctionsAPI,
  searchFunctionsAPI,
  createFunctionAPI,
  modifyFunctionAPI,
  deleteFunctionAPI,
  uploadConceptsFormulasFormFileAPI,
  duplicateFunctionAPI,
  geminiChatAPI,
} from "@icarius-connection/api";

//Concept and formulas
export const getConceptsAndFormulasRows = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CONCEPTS_AND_FORMULAS });
  try {
    let response = await getConceptAndFormulasAPI();
    let gridData = response.data && response.data.data;
    let grupos = response.data && response.data.grupos;
    let nominas = response.data && response.data.nominas;
    let acumuladores = response.data && response.data.acumuladores;
    let disponibilidad = response.data && response.data.disponibilidad;
    let familia = response.data && response.data.familia;
    let clasificacion = response.data && response.data.clasificacion;
    let discountArray = response.data && response.data.discountArray;
    let isAdmin = response.data && response.data.isAdmin;

    dispatch({
      type: actionTypes.GET_CONCEPTS_AND_FORMULAS_FULFILLED,
      payload: { gridData, grupos, nominas, acumuladores, disponibilidad, familia, clasificacion, discountArray, isAdmin, },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_CONCEPTS_AND_FORMULAS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const searchConceptsAction = (query) => async (dispatch) => {
  dispatch({ type: actionTypes.SEARCH_CONCEPTS });
  try {
    let response = await searchConceptsAPI(`?token=${query}`);

    dispatch({
      type: actionTypes.SEARCH_CONCEPTS_FULFILLED
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.SEARCH_CONCEPTS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const getConceptDetailsAction = (code) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CONCEPT_DETAILS });
  try {
    let response = await getConceptDetailsAPI(`?code=${code}`);
    let maxSeq = response.data && response.data.maxSeq;
    let checkboxes = response.data && response.data.checkboxes;
    let formula = response.data && response.data.formula;
    let formulaPersonalizada = response.data && response.data.formulaPersonalizada;
    let esFormulaPersonalizada = response.data && response.data.esFormPersonalizada;

    dispatch({
      type: actionTypes.GET_CONCEPT_DETAILS_FULFILLED,
      payload: { maxSeq, checkboxes, formula, formulaPersonalizada, esFormulaPersonalizada },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_CONCEPT_DETAILS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    return e;
  }
};

export const createConceptAndFormulasAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_CONCEPTS_AND_FORMULAS });
  try {
    let response = await createConceptAndFormulasAPI(data);
    let gridData = response.data && response.data.data;
    let status = response.data && response.data.status;

    dispatch({ type: actionTypes.CREATE_CONCEPTS_AND_FORMULAS_FULFILLED, payload: { gridData } });

    if (status === "OK") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("conceptCreatedSuccessfully"), severity: "success" }));
    }

    if (status === "OK_WARNING") {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("conceptCreatedSuccessfullyRememberToAssignToAnIncomeStructureOrConceptSet"),
        severity: "info",
        duration: null
      }));
    }

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveConceptsWithSameCode"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.CREATE_CONCEPTS_AND_FORMULAS_REJECTED, payload: e });
    return e.response;
  }
};

export const modifyConceptAndFormulasAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_CONCEPTS_AND_FORMULAS });
  try {
    let response = await modifyConceptAndFormulasAPI(data);
    let gridData = response.data && response.data.data;
    let status = response.data && response.data.status;

    dispatch({ type: actionTypes.MODIFY_CONCEPTS_AND_FORMULAS_FULFILLED, payload: { gridData } });

    if (status === "OK") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("conceptModifiedSuccessfully"), severity: "success" }));
    }

    if (status === "OK_WARNING") {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("conceptModifiedSuccessfullyRememberToAssignConceptToAnIncomeStructureOrConceptSet"),
        severity: "info",
        duration: null
      }));
    }

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveConceptsWithSameCode"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.MODIFY_CONCEPTS_AND_FORMULAS_REJECTED, payload: e });
    return e.response;
  }
};

export const deleteCentersSettingsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_CONCEPTS_AND_FORMULAS });
  try {
    let response = await deleteConceptAndFormulasAPI(data);
    let gridData = response.data && response.data.data;

    dispatch({ type: actionTypes.DELETE_CONCEPTS_AND_FORMULAS_FULFILLED, payload: { gridData } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("conceptDeletedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "CONCEPT_IN_USE") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotDeleteConceptBecauseItIsInUse"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.DELETE_CONCEPTS_AND_FORMULAS_REJECTED, payload: e });
    return e.response;
  }
};

export const duplicateConceptAndFormulasAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DUPLICATE_CONCEPTS_AND_FORMULAS });
  try {
    let response = await duplicateConceptAndFormulasAPI(data);
    let gridData = response.data && response.data.data;

    dispatch({ type: actionTypes.DUPLICATE_CONCEPTS_AND_FORMULAS_FULFILLED, payload: { gridData } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("conceptDuplicatedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveConceptsWithSameCode"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.DUPLICATE_CONCEPTS_AND_FORMULAS_REJECTED, payload: e });
    return e.response;
  }
};

//Functions
export const getFunctionRowsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_FUNCTIONS });
  try {
    let response = await getFunctionsAPI();
    let gridData = response.data && response.data.data;
    let applications = response.data && response.data.types;
    let maxSequences = response.data && response.data.maxSequences;
    let isAdmin = response.data && response.data.isAdmin;

    dispatch({
      type: actionTypes.GET_FUNCTIONS_FULFILLED,
      payload: { gridData, applications, maxSequences, isAdmin },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_FUNCTIONS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const searchFunctionsAction = (query) => async (dispatch) => {
  dispatch({ type: actionTypes.SEARCH_FUNCTIONS });
  try {
    let response = await searchFunctionsAPI(`?token=${query}`);

    dispatch({
      type: actionTypes.SEARCH_FUNCTIONS_FULFILLED
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.SEARCH_FUNCTIONS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const createFunctionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_FUNCTION });
  try {
    let response = await createFunctionAPI(data);
    let gridData = response.data && response.data.data;
    let maxSequences = response.data && response.data.maxSequences;

    dispatch({ type: actionTypes.CREATE_FUNCTION_FULFILLED, payload: { gridData, maxSequences } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("functionCreatedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotExistFunctionsWithSameCode"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.CREATE_FUNCTION_REJECTED, payload: e });
    return e.response;
  }
};

export const modifyFunctionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY_FUNCTION });
  try {
    let response = await modifyFunctionAPI(data);
    let gridData = response.data && response.data.data;
    let maxSequences = response.data && response.data.maxSequences;

    dispatch({ type: actionTypes.MODIFY_FUNCTION_FULFILLED, payload: { gridData, maxSequences } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("functionModifiedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotExistFunctionsWithSameCode"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.MODIFY_FUNCTION_REJECTED, payload: e });
    return e.response;
  }
};

export const deleteFunctionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_FUNCTION });
  try {
    let response = await deleteFunctionAPI(data);
    let gridData = response.data && response.data.data;
    let maxSequences = response.data && response.data.maxSequences;

    dispatch({ type: actionTypes.DELETE_FUNCTION_FULFILLED, payload: { gridData, maxSequences } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("functionDeletedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "FUNCTION_IN_USE") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cantDeleteFunction"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.DELETE_FUNCTION_REJECTED, payload: e });
    return e.response;
  }
};

export const duplicateFunctionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DUPLICATE_FUNCTION });
  try {
    let response = await duplicateFunctionAPI(data);
    let gridData = response.data && response.data.data;

    dispatch({ type: actionTypes.DUPLICATE_FUNCTION_FULFILLED, payload: { gridData } });
    dispatch(openSnackbarAction({ msg: getLocalizedString("functionDuplicatedSuccessfully"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("cannotHaveFunctionsWithSameName"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.DUPLICATE_FUNCTION_REJECTED, payload: e });
    return e.response;
  }
};

export const uploadConceptsFormulasFormFileAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.FORM_FILE_UPLOAD });
  try {
    let formData = new FormData();
    Object.keys(dataToSend).forEach((key) => formData.append(key, dataToSend[key]));
    let response = await uploadConceptsFormulasFormFileAPI(formData);
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.FORM_FILE_UPLOAD_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.FORM_FILE_UPLOAD_FULFILLED,
    });

    return response;
  } catch (e) {
    dispatch({ type: actionTypes.FORM_FILE_UPLOAD_REJECTED, payload: e });
    return e.response;
  }
};

export const geminiChatAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.GEMINI_CHAT_REQUEST, payload: { conversationId: data.id } });
  try {
    let formData = new FormData();
    formData.append('prompt', data.prompt);

    if (data.conversationId) {
      formData.append('conversationId', data.conversationId);
      formData.append('origin', data.origin);
    } else {
      formData.append('type', data.type);
      formData.append('id', data.id);
      formData.append('origin', data.origin);
      formData.append('attachment', data.file, "Archivo de contexto.csv");
    }

    let response = await geminiChatAPI(formData);

    if (response.data && response.data.status === "OK") {
      dispatch({ type: actionTypes.GEMINI_CHAT_FULFILLED, payload: response.data });
    }
    dispatch({ type: actionTypes.GEMINI_CHAT_REQUEST_END, payload: { conversationId: data.id } });
    return response;
  } catch (e) {
    if (e?.response?.data?.status === "RUNTIME_ERROR") {
      dispatch(openSnackbarAction({ msg: e.response.data.text, severity: "error", duration: 10000 }));
    }
    dispatch({ type: actionTypes.GEMINI_CHAT_REQUEST_END, payload: { conversationId: data.id } });
    return e.response;
  }
};

export const geminiResetChatAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GEMINI_CHAT_RESET });
}